export enum BooksAllowedEnum {
  BASE_KNOWLEDGE = 59,
  ADDITIONAL_KNOWLEDGE_CATEGORY_B = 60,
  ADDITIONAL_KNOWLEDGE_CATEGORY_A = 61,
}
